var _defs, _rect, _path, _path2, _path3, _g, _g2, _g3, _g4, _g5, _defs2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoMain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    width: 2400,
    height: 536.2726764942438,
    viewBox: "77.91756851196288 104.4244578552246 184.16486297607423 41.15107666015625",
    preserveAspectRatio: "xMidYMid meet",
    colorInterpolationFilters: "sRGB",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: 92,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fa71cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9b59b6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 93,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f9d423"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#f83600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 94,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0064d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1cb0f6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 95,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f00978"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#3f51b1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 96,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7873f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ec77ab"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 97,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f9d423"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#e14fad"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 98,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#009efd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2af598"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 99,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ffcc00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00b140"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 100,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#d51007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ff8177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 102,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#a2b6df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0c3483"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 103,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7ac5d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#eea2a2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 104,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00ecbc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#007adf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 105,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#b88746"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#fdf5a6"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "#147dc8",
    className: "iconlinesvg-g iconlinesvg",
    transform: "translate(79.72310638427734,106.23157119750977)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "tp-name"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 2.349197160329023)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "imagesvg"
  }, /*#__PURE__*/React.createElement("g", null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#147dc8",
    fillOpacity: 0,
    strokeWidth: 2,
    x: 0,
    y: 0,
    width: 37.31748005317544,
    height: 32.83659790329219,
    className: "image-rect"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    x: 0,
    y: 0,
    width: 37.31748005317544,
    height: 32.83659790329219,
    filtersec: "colorsb9257513743",
    className: "image-svg-svg primary",
    style: {
      overflow: "visible"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 144.8300018310547 127.44000244140625",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#147dc8",
    d: "M0 127.44h50.38l47.07-83.06L72.27 0 0 127.44z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#143d8f",
    d: "M144.83 127.44H94.45L47.08 44.38 72.27 0l72.56 127.44z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M72.27 88.76l25.18-44.38L72.27 0 47.08 44.38l25.19 44.38z"
  })))))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(41, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#147dc8",
    transform: "scale(1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.32-26.43L12.32 0L3.20 0L3.20-26.43L12.32-26.43ZM2.96-33.01L2.96-33.01Q2.96-35.06 4.11-36.07Q5.25-37.07 7.79-37.07L7.79-37.07Q10.33-37.07 11.50-36.04Q12.67-35.02 12.67-33.01L12.67-33.01Q12.67-29.00 7.79-29.00L7.79-29.00Q2.96-29.00 2.96-33.01Z",
    transform: "translate(-2.962674961119751, 37.06842923794712)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(54, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#147dc8",
    transform: "scale(1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.72 0L35.60 0L35.60-14.37Q35.60-17.05 34.86-18.39Q34.13-19.74 32.54-19.74L32.54-19.74Q30.44-19.74 29.46-17.94Q28.48-16.14 28.48-12.32L28.48-12.32L28.48 0L19.34 0L19.34-14.37Q19.34-17.05 18.64-18.39Q17.94-19.74 16.38-19.74L16.38-19.74Q14.23-19.74 13.25-17.82Q12.27-15.91 12.27-11.57L12.27-11.57L12.27 0L3.15 0L3.15-26.43L10.03-26.43L11.17-23.16L11.71-23.16Q12.76-24.98 14.76-25.94Q16.75-26.90 19.29-26.90L19.29-26.90Q25.01-26.90 27.32-23.42L27.32-23.42L28.04-23.42Q29.16-25.05 31.15-25.98Q33.15-26.90 35.55-26.90L35.55-26.90Q40.24-26.90 42.48-24.49Q44.72-22.09 44.72-17.19L44.72-17.19L44.72 0Z",
    transform: "translate(-3.1493001555209954, 37.06842923794712)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(99, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#147dc8",
    transform: "scale(1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.36 0.47L11.36 0.47Q8.54 0.47 6.43-1.14Q4.32-2.75 3.16-5.88Q2.01-9.00 2.01-13.18L2.01-13.18Q2.01-19.62 4.60-23.26Q7.19-26.90 11.71-26.90L11.71-26.90Q13.93-26.90 15.59-26.01Q17.26-25.12 18.64-23.02L18.64-23.02L18.83-23.02Q18.38-26.13 18.38-29.23L18.38-29.23L18.38-36.30L27.57-36.30L27.57 0L20.69 0L18.73-3.34L18.38-3.34Q16.03 0.47 11.36 0.47ZM15.09-6.74L15.09-6.74Q17.29-6.74 18.18-8.12Q19.08-9.49 19.15-12.36L19.15-12.36L19.15-13.09Q19.15-16.59 18.15-18.07Q17.15-19.55 15.00-19.55L15.00-19.55Q13.20-19.55 12.21-17.86Q11.22-16.17 11.22-13.04L11.22-13.04Q11.22-9.96 12.22-8.35Q13.23-6.74 15.09-6.74Z",
    transform: "translate(-2.0062208398133747, 37.06842923794712)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(128, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#147dc8",
    transform: "scale(1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.39-13.27L28.39-13.27Q28.39-6.79 24.90-3.16Q21.42 0.47 15.14 0.47L15.14 0.47Q9.12 0.47 5.56-3.24Q2.01-6.95 2.01-13.27L2.01-13.27Q2.01-19.74 5.49-23.32Q8.98-26.90 15.28-26.90L15.28-26.90Q19.18-26.90 22.16-25.24Q25.15-23.58 26.77-20.49Q28.39-17.40 28.39-13.27ZM11.27-13.27L11.27-13.27Q11.27-9.87 12.18-8.08Q13.09-6.30 15.23-6.30L15.23-6.30Q17.36-6.30 18.23-8.08Q19.11-9.87 19.11-13.27L19.11-13.27Q19.11-16.66 18.22-18.38Q17.33-20.11 15.19-20.11L15.19-20.11Q13.09-20.11 12.18-18.39Q11.27-16.68 11.27-13.27Z",
    transform: "translate(-2.0062208398133747, 37.06842923794712)"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(158, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#147dc8",
    transform: "scale(1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.19 0.47L15.19 0.47Q8.70 0.47 5.35-3.03Q2.01-6.53 2.01-13.09L2.01-13.09Q2.01-19.67 5.62-23.28Q9.24-26.90 15.91-26.90L15.91-26.90Q20.51-26.90 24.56-24.89L24.56-24.89L21.88-18.15Q20.23-18.87 18.83-19.30Q17.43-19.74 15.91-19.74L15.91-19.74Q13.69-19.74 12.48-18.01Q11.27-16.28 11.27-13.13L11.27-13.13Q11.27-6.79 15.96-6.79L15.96-6.79Q19.97-6.79 23.65-9.12L23.65-9.12L23.65-1.87Q20.13 0.47 15.19 0.47Z",
    transform: "translate(-2.0062208398133747, 37.06842923794712)"
  })))))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", {
    "v-gra": "od"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMain);
export default __webpack_public_path__ + "static/media/logo_main.8d49adcbbec7e9bc304b6695341d1233.svg";
export { ForwardRef as ReactComponent };